import { useQuery } from "@tanstack/react-query";
import { fetchCameras } from "~/_legacy/apis/fetch-cameras";

export const CAMERAS_BY_BRANCH_QUERY_KEY = "camerasByBranch";

export function useGetCamerasByBranch({
  branchUid,
  branchVersionId,
}: {
  branchUid?: string;
  branchVersionId?: number;
}) {
  return useQuery({
    queryKey: [CAMERAS_BY_BRANCH_QUERY_KEY, branchUid, branchVersionId],
    queryFn: () => fetchCameras({ branchUid: branchUid!, branchVersionId }),
    enabled: Boolean(branchUid),
  });
}
